import { TabContext, TabList, TabPanel } from '@material-ui/lab';
import { Tab } from '@material-ui/core';
import { useStyles } from '@webapps/styles';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useQuery, useAuth } from '@webapps/reactjs-tech-components';
import { getRelationsByCFA, searchTrainingsByRelations, searchRelations } from '@webapps/business';
import { useFormik } from 'formik';


import Relations from './Relations';
import Trainings from './Trainings';

const Organismes = () => {
  const { classes, global, css, cx } = useStyles(styles);

  const { idUser } = useAuth();

  const [tabValue, setTabValue] = useState('1');
  const [sizeSchools, setSizeSchools] = useState(window.innerWidth > 1770 ? 8 : window.innerWidth > 1024 ? 6 : 4);
  const [pageSchools, setPageSchools] = useState(1);
  const [sizeTrainings, setSizeTrainings] = useState(window.innerWidth > 1770 ? 8 : window.innerWidth > 1024 ? 6 : 4);
  const [pageTrainings, setPageTrainings] = useState(1);

  const { state } = useLocation();

  useEffect(() => {
    if (state?.schoolId) {
      setTabValue('2');
      formikTrainings.setFieldValue('school', { id: state?.schoolId });
    } else if (state?.toTraining) {
      setTabValue('2');
      formikTrainings.setFieldValue('trainingLabel', state?.label);
    }
  }, [state]);

  const formikSchools = useFormik({
    initialValues: {
      school: "",
    },
    onSubmit: (values) => {
      setSchoolsId(values.schoolsId);
    },
  });

  const formikTrainings = useFormik({
    initialValues: {
      school: state?.schoolId ? { id: state?.schoolId } : "",
      trainingLabel: "",
      rncp: "",
      diplomaCode: "",
    },
    onSubmit: (values) => {
      setTrainingsId(values.schoolsId);
    },
  });

  const { data: { content: relationsList = [] } = {} } = useQuery(getRelationsByCFA, {
    key: ['relationsList'],
    variables: { id: idUser, size: 100, page: 0 },
    keepPreviousData: true
  });

  const { data: { content: relations = [], totalElements: totalSchools } = {}, refetch: refetchSchools, isFetching: isLoadingSchools } = useQuery(searchRelations, {
    key: ['relations', sizeSchools, pageSchools, formikSchools?.values],
    variables: {
      id: idUser,
      schoolsId: formikSchools?.values?.school?.id,
      size: sizeSchools,
      page: pageSchools - 1
    },
  });

  const { data: { content: trainings = [], totalElements: totalTrainings } = {}, refetch: refetchTrainings, isLoading: isLoadingTrainings } = useQuery(searchTrainingsByRelations, {
    key: ['training', idUser, sizeTrainings, pageTrainings, formikTrainings?.values],
    variables: {
      id: idUser,
      schoolsId: formikTrainings?.values?.school?.id,
      trainingLabel: formikTrainings?.values?.trainingLabel,
      rncp: formikTrainings?.values?.rncp,
      diplomaCode: formikTrainings?.values?.diplomaCode,
      size: sizeTrainings,
      page: pageTrainings - 1,
    },
  });


  return (
    <div
      style={{ minHeight: 'calc(100vh - 65px)' }}
      className={((isLoadingSchools || (totalSchools > 0 && tabValue === '1')) || (isLoadingTrainings || (totalTrainings > 0 && tabValue === '2'))) ? global.container : global.containerNoScrollWithTab}>
      <TabContext value={tabValue} style={{ height: (totalSchools > 0 && tabValue === '1') || (totalTrainings > 0 && tabValue === '2') ? '100%' : 'initial' }}>
        <TabList className={classes.tabContainer} indicatorColor="default" onChange={(e, v) => setTabValue(v)} >
          <Tab className={[global.mainTitle, global.tab, tabValue === '1' && global.activeTab]} label={`Organismes de formation (${totalSchools || 0})`} value="1" />
          <Tab className={[global.mainTitle, global.tab, tabValue === '2' && global.activeTab]} label={`Formations (${totalTrainings || 0})`} value="2" />
        </TabList>
        {tabValue === '1' && <div
          style={{ height: (relations?.length > 0 && tabValue === '1') ? 'initial' : 'calc(100% - 50px)' }}
        >
          <TabPanel className={cx(global.tabPanel,
            css({
              paddingBottom: (totalSchools > 0 && tabValue === '1') ? '20px' : '30px'
            })
          )} value="1" >
            <Relations
              relationsList={relationsList}
              relations={relations}
              refetch={() => { refetchTrainings(); refetchSchools() }}
              setPage={setPageSchools}
              page={pageSchools}
              size={sizeSchools}
              totalElements={totalSchools}
              formik={formikSchools}
              isLoading={isLoadingSchools}
            />
          </TabPanel>
        </div>}
        {tabValue === '2' && <div
          style={{ height: (trainings?.length > 0 && tabValue === '2') ? 'initial' : 'calc(100% - 50px)' }}
        >
          <TabPanel className={cx(global.tabPanel,
            css({
              paddingBottom: (totalTrainings > 0 && tabValue === '2') ? '20px' : '30px'
            })
          )} value="2" >
            <Trainings
              relationsList={relationsList}
              trainings={trainings}
              refetch={() => { refetchTrainings(); refetchSchools() }}
              setPage={setPageTrainings}
              page={pageTrainings}
              size={sizeTrainings}
              totalElements={totalTrainings}
              formik={formikTrainings}
              isLoading={isLoadingTrainings}
            />
          </TabPanel>
        </div>
        }
      </TabContext>
    </div>

  );
};

const styles = ({ }) => ({

});

export default Organismes;